import type {
  PagedDialogueLogs,
  DialogueLog,
  DialogueLogCreateRequest,
  DialogueLogListQuery,
  DialogueLogPatchRequest,
} from '@shared/types/dialogue-log';
import { api } from './client';

function buildQueryString(query: DialogueLogListQuery): string {
  const params = new URLSearchParams();
  for (const [key, value] of Object.entries(query)) {
    if (value === undefined || value === null || value === '') continue;
    params.set(key, String(value));
  }
  const qs = params.toString();
  return qs.length === 0 ? '' : `?${qs}`;
}

export async function listDialogueLogs(
  query: DialogueLogListQuery = {},
): Promise<PagedDialogueLogs> {
  return api.get<PagedDialogueLogs>(`/api/dialogue-logs${buildQueryString(query)}`);
}

export async function getDialogueLog(id: string): Promise<DialogueLog> {
  return api.get<DialogueLog>(`/api/dialogue-logs/${encodeURIComponent(id)}`);
}

export async function createDialogueLog(
  body: DialogueLogCreateRequest,
): Promise<DialogueLog> {
  return api.post<DialogueLog>('/api/dialogue-logs', body);
}

export async function patchDialogueLog(
  id: string,
  body: DialogueLogPatchRequest,
): Promise<DialogueLog> {
  return api.patch<DialogueLog>(`/api/dialogue-logs/${encodeURIComponent(id)}`, body);
}

export async function deleteDialogueLog(id: string): Promise<void> {
  return api.delete(`/api/dialogue-logs/${encodeURIComponent(id)}`);
}
